import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type DeleteIglooVisitorKeyRequest = {
  clientId: string
  guestId: string
}

// Note: There is no standalone endpoint to revoke just a guest's Igloo key — backend-confirmed
// (EL-11416, Vladyslav, against live staging source). PUT /client/:clientId/guest/:guestId/suspend
// is the canonical mapping for "revoke this guest's Igloo key": it keeps the guest record intact
// and revokes their Igloo key server-side, reversible via the matching .../restore route (which
// re-issues the key). The previously mocked GET/PATCH/DELETE /visitor/:guestId/keys contract does
// not exist and is not coming.
const deleteIglooVisitorKey = async ({ clientId, guestId }: DeleteIglooVisitorKeyRequest) => {
  const response = await authAPI.put(`/client/${clientId}/guest/${guestId}/suspend`, {})
  return response.data
}

export const useDeleteIglooVisitorKey = () =>
  useMutation({
    mutationFn: (data: DeleteIglooVisitorKeyRequest) => deleteIglooVisitorKey(data),
  })
